module.exports = __webpack_public_path__ + "img/16.ad717e1.jpg";